/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JoinRouteImport } from './routes/join'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedByeRouteImport } from './routes/_authenticated/bye'
import { Route as AuthenticatedSidebarLayoutRouteImport } from './routes/_authenticated/_sidebarLayout'
import { Route as AuthenticatedSidebarLayoutIndexRouteImport } from './routes/_authenticated/_sidebarLayout/index'
import { Route as AuthenticatedSidebarLayoutSettingsRouteImport } from './routes/_authenticated/_sidebarLayout/settings'
import { Route as AuthenticatedSidebarLayoutProductsRouteImport } from './routes/_authenticated/_sidebarLayout/products'
import { Route as AuthenticatedSidebarLayoutOrganisationRouteImport } from './routes/_authenticated/_sidebarLayout/organisation'
import { Route as AuthenticatedSidebarLayoutListsRouteImport } from './routes/_authenticated/_sidebarLayout/lists'
import { Route as AuthenticatedSidebarLayoutCampaignsRouteImport } from './routes/_authenticated/_sidebarLayout/campaigns'
import { Route as AuthenticatedSidebarLayoutProductCreateRouteImport } from './routes/_authenticated/_sidebarLayout/product/create'
import { Route as AuthenticatedSidebarLayoutListListIdRouteImport } from './routes/_authenticated/_sidebarLayout/list/$listId'
import { Route as AuthenticatedSidebarLayoutCampaignCreateRouteImport } from './routes/_authenticated/_sidebarLayout/campaign/create'
import { Route as AuthenticatedSidebarLayoutProductProductIdUpdateRouteImport } from './routes/_authenticated/_sidebarLayout/product/$productId/update'
import { Route as AuthenticatedSidebarLayoutCampaignCampaignIdDetailRouteImport } from './routes/_authenticated/_sidebarLayout/campaign/$campaignId/detail'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedByeRoute = AuthenticatedByeRouteImport.update({
  id: '/bye',
  path: '/bye',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSidebarLayoutRoute =
  AuthenticatedSidebarLayoutRouteImport.update({
    id: '/_sidebarLayout',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSidebarLayoutIndexRoute =
  AuthenticatedSidebarLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutSettingsRoute =
  AuthenticatedSidebarLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutProductsRoute =
  AuthenticatedSidebarLayoutProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutOrganisationRoute =
  AuthenticatedSidebarLayoutOrganisationRouteImport.update({
    id: '/organisation',
    path: '/organisation',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutListsRoute =
  AuthenticatedSidebarLayoutListsRouteImport.update({
    id: '/lists',
    path: '/lists',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutCampaignsRoute =
  AuthenticatedSidebarLayoutCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutProductCreateRoute =
  AuthenticatedSidebarLayoutProductCreateRouteImport.update({
    id: '/product/create',
    path: '/product/create',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutListListIdRoute =
  AuthenticatedSidebarLayoutListListIdRouteImport.update({
    id: '/list/$listId',
    path: '/list/$listId',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutCampaignCreateRoute =
  AuthenticatedSidebarLayoutCampaignCreateRouteImport.update({
    id: '/campaign/create',
    path: '/campaign/create',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutProductProductIdUpdateRoute =
  AuthenticatedSidebarLayoutProductProductIdUpdateRouteImport.update({
    id: '/product/$productId/update',
    path: '/product/$productId/update',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutCampaignCampaignIdDetailRoute =
  AuthenticatedSidebarLayoutCampaignCampaignIdDetailRouteImport.update({
    id: '/campaign/$campaignId/detail',
    path: '/campaign/$campaignId/detail',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/callback': typeof CallbackRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/bye': typeof AuthenticatedByeRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/campaigns': typeof AuthenticatedSidebarLayoutCampaignsRoute
  '/lists': typeof AuthenticatedSidebarLayoutListsRoute
  '/organisation': typeof AuthenticatedSidebarLayoutOrganisationRoute
  '/products': typeof AuthenticatedSidebarLayoutProductsRoute
  '/settings': typeof AuthenticatedSidebarLayoutSettingsRoute
  '/': typeof AuthenticatedSidebarLayoutIndexRoute
  '/campaign/create': typeof AuthenticatedSidebarLayoutCampaignCreateRoute
  '/list/$listId': typeof AuthenticatedSidebarLayoutListListIdRoute
  '/product/create': typeof AuthenticatedSidebarLayoutProductCreateRoute
  '/campaign/$campaignId/detail': typeof AuthenticatedSidebarLayoutCampaignCampaignIdDetailRoute
  '/product/$productId/update': typeof AuthenticatedSidebarLayoutProductProductIdUpdateRoute
}
export interface FileRoutesByTo {
  '/callback': typeof CallbackRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/bye': typeof AuthenticatedByeRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/campaigns': typeof AuthenticatedSidebarLayoutCampaignsRoute
  '/lists': typeof AuthenticatedSidebarLayoutListsRoute
  '/organisation': typeof AuthenticatedSidebarLayoutOrganisationRoute
  '/products': typeof AuthenticatedSidebarLayoutProductsRoute
  '/settings': typeof AuthenticatedSidebarLayoutSettingsRoute
  '/': typeof AuthenticatedSidebarLayoutIndexRoute
  '/campaign/create': typeof AuthenticatedSidebarLayoutCampaignCreateRoute
  '/list/$listId': typeof AuthenticatedSidebarLayoutListListIdRoute
  '/product/create': typeof AuthenticatedSidebarLayoutProductCreateRoute
  '/campaign/$campaignId/detail': typeof AuthenticatedSidebarLayoutCampaignCampaignIdDetailRoute
  '/product/$productId/update': typeof AuthenticatedSidebarLayoutProductProductIdUpdateRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/callback': typeof CallbackRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/_authenticated/_sidebarLayout': typeof AuthenticatedSidebarLayoutRouteWithChildren
  '/_authenticated/bye': typeof AuthenticatedByeRoute
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/_authenticated/_sidebarLayout/campaigns': typeof AuthenticatedSidebarLayoutCampaignsRoute
  '/_authenticated/_sidebarLayout/lists': typeof AuthenticatedSidebarLayoutListsRoute
  '/_authenticated/_sidebarLayout/organisation': typeof AuthenticatedSidebarLayoutOrganisationRoute
  '/_authenticated/_sidebarLayout/products': typeof AuthenticatedSidebarLayoutProductsRoute
  '/_authenticated/_sidebarLayout/settings': typeof AuthenticatedSidebarLayoutSettingsRoute
  '/_authenticated/_sidebarLayout/': typeof AuthenticatedSidebarLayoutIndexRoute
  '/_authenticated/_sidebarLayout/campaign/create': typeof AuthenticatedSidebarLayoutCampaignCreateRoute
  '/_authenticated/_sidebarLayout/list/$listId': typeof AuthenticatedSidebarLayoutListListIdRoute
  '/_authenticated/_sidebarLayout/product/create': typeof AuthenticatedSidebarLayoutProductCreateRoute
  '/_authenticated/_sidebarLayout/campaign/$campaignId/detail': typeof AuthenticatedSidebarLayoutCampaignCampaignIdDetailRoute
  '/_authenticated/_sidebarLayout/product/$productId/update': typeof AuthenticatedSidebarLayoutProductProductIdUpdateRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/callback'
    | '/join'
    | '/login'
    | '/bye'
    | '/onboarding'
    | '/campaigns'
    | '/lists'
    | '/organisation'
    | '/products'
    | '/settings'
    | '/'
    | '/campaign/create'
    | '/list/$listId'
    | '/product/create'
    | '/campaign/$campaignId/detail'
    | '/product/$productId/update'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/callback'
    | '/join'
    | '/login'
    | '/bye'
    | '/onboarding'
    | '/campaigns'
    | '/lists'
    | '/organisation'
    | '/products'
    | '/settings'
    | '/'
    | '/campaign/create'
    | '/list/$listId'
    | '/product/create'
    | '/campaign/$campaignId/detail'
    | '/product/$productId/update'
  id:
    | '__root__'
    | '/_authenticated'
    | '/callback'
    | '/join'
    | '/login'
    | '/_authenticated/_sidebarLayout'
    | '/_authenticated/bye'
    | '/_authenticated/onboarding'
    | '/_authenticated/_sidebarLayout/campaigns'
    | '/_authenticated/_sidebarLayout/lists'
    | '/_authenticated/_sidebarLayout/organisation'
    | '/_authenticated/_sidebarLayout/products'
    | '/_authenticated/_sidebarLayout/settings'
    | '/_authenticated/_sidebarLayout/'
    | '/_authenticated/_sidebarLayout/campaign/create'
    | '/_authenticated/_sidebarLayout/list/$listId'
    | '/_authenticated/_sidebarLayout/product/create'
    | '/_authenticated/_sidebarLayout/campaign/$campaignId/detail'
    | '/_authenticated/_sidebarLayout/product/$productId/update'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  JoinRoute: typeof JoinRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bye': {
      id: '/_authenticated/bye'
      path: '/bye'
      fullPath: '/bye'
      preLoaderRoute: typeof AuthenticatedByeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_sidebarLayout': {
      id: '/_authenticated/_sidebarLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedSidebarLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_sidebarLayout/': {
      id: '/_authenticated/_sidebarLayout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebarLayout/settings': {
      id: '/_authenticated/_sidebarLayout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutSettingsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebarLayout/products': {
      id: '/_authenticated/_sidebarLayout/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProductsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebarLayout/organisation': {
      id: '/_authenticated/_sidebarLayout/organisation'
      path: '/organisation'
      fullPath: '/organisation'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutOrganisationRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebarLayout/lists': {
      id: '/_authenticated/_sidebarLayout/lists'
      path: '/lists'
      fullPath: '/lists'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutListsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebarLayout/campaigns': {
      id: '/_authenticated/_sidebarLayout/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutCampaignsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebarLayout/product/create': {
      id: '/_authenticated/_sidebarLayout/product/create'
      path: '/product/create'
      fullPath: '/product/create'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProductCreateRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebarLayout/list/$listId': {
      id: '/_authenticated/_sidebarLayout/list/$listId'
      path: '/list/$listId'
      fullPath: '/list/$listId'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutListListIdRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebarLayout/campaign/create': {
      id: '/_authenticated/_sidebarLayout/campaign/create'
      path: '/campaign/create'
      fullPath: '/campaign/create'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutCampaignCreateRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebarLayout/product/$productId/update': {
      id: '/_authenticated/_sidebarLayout/product/$productId/update'
      path: '/product/$productId/update'
      fullPath: '/product/$productId/update'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProductProductIdUpdateRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebarLayout/campaign/$campaignId/detail': {
      id: '/_authenticated/_sidebarLayout/campaign/$campaignId/detail'
      path: '/campaign/$campaignId/detail'
      fullPath: '/campaign/$campaignId/detail'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutCampaignCampaignIdDetailRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
  }
}

interface AuthenticatedSidebarLayoutRouteChildren {
  AuthenticatedSidebarLayoutCampaignsRoute: typeof AuthenticatedSidebarLayoutCampaignsRoute
  AuthenticatedSidebarLayoutListsRoute: typeof AuthenticatedSidebarLayoutListsRoute
  AuthenticatedSidebarLayoutOrganisationRoute: typeof AuthenticatedSidebarLayoutOrganisationRoute
  AuthenticatedSidebarLayoutProductsRoute: typeof AuthenticatedSidebarLayoutProductsRoute
  AuthenticatedSidebarLayoutSettingsRoute: typeof AuthenticatedSidebarLayoutSettingsRoute
  AuthenticatedSidebarLayoutIndexRoute: typeof AuthenticatedSidebarLayoutIndexRoute
  AuthenticatedSidebarLayoutCampaignCreateRoute: typeof AuthenticatedSidebarLayoutCampaignCreateRoute
  AuthenticatedSidebarLayoutListListIdRoute: typeof AuthenticatedSidebarLayoutListListIdRoute
  AuthenticatedSidebarLayoutProductCreateRoute: typeof AuthenticatedSidebarLayoutProductCreateRoute
  AuthenticatedSidebarLayoutCampaignCampaignIdDetailRoute: typeof AuthenticatedSidebarLayoutCampaignCampaignIdDetailRoute
  AuthenticatedSidebarLayoutProductProductIdUpdateRoute: typeof AuthenticatedSidebarLayoutProductProductIdUpdateRoute
}

const AuthenticatedSidebarLayoutRouteChildren: AuthenticatedSidebarLayoutRouteChildren =
  {
    AuthenticatedSidebarLayoutCampaignsRoute:
      AuthenticatedSidebarLayoutCampaignsRoute,
    AuthenticatedSidebarLayoutListsRoute: AuthenticatedSidebarLayoutListsRoute,
    AuthenticatedSidebarLayoutOrganisationRoute:
      AuthenticatedSidebarLayoutOrganisationRoute,
    AuthenticatedSidebarLayoutProductsRoute:
      AuthenticatedSidebarLayoutProductsRoute,
    AuthenticatedSidebarLayoutSettingsRoute:
      AuthenticatedSidebarLayoutSettingsRoute,
    AuthenticatedSidebarLayoutIndexRoute: AuthenticatedSidebarLayoutIndexRoute,
    AuthenticatedSidebarLayoutCampaignCreateRoute:
      AuthenticatedSidebarLayoutCampaignCreateRoute,
    AuthenticatedSidebarLayoutListListIdRoute:
      AuthenticatedSidebarLayoutListListIdRoute,
    AuthenticatedSidebarLayoutProductCreateRoute:
      AuthenticatedSidebarLayoutProductCreateRoute,
    AuthenticatedSidebarLayoutCampaignCampaignIdDetailRoute:
      AuthenticatedSidebarLayoutCampaignCampaignIdDetailRoute,
    AuthenticatedSidebarLayoutProductProductIdUpdateRoute:
      AuthenticatedSidebarLayoutProductProductIdUpdateRoute,
  }

const AuthenticatedSidebarLayoutRouteWithChildren =
  AuthenticatedSidebarLayoutRoute._addFileChildren(
    AuthenticatedSidebarLayoutRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedSidebarLayoutRoute: typeof AuthenticatedSidebarLayoutRouteWithChildren
  AuthenticatedByeRoute: typeof AuthenticatedByeRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSidebarLayoutRoute: AuthenticatedSidebarLayoutRouteWithChildren,
  AuthenticatedByeRoute: AuthenticatedByeRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CallbackRoute: CallbackRoute,
  JoinRoute: JoinRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
